import * as Constants from "../constants";

export const updateScheduleFormTitleInput = (value) => ({
  type: Constants.SCHEDULE_FORM_TITLE_CHANGE,
  payload: value,
});

export const updateScheduleFormDateInput = (value) => ({
  type: Constants.SCHEDULE_FORM_DATE_CHANGE,
  payload: value,
});

export const updateScheduleFormTimeInput = (value) => ({
  type: Constants.SCHEDULE_FORM_TIME_CHANGE,
  payload: value,
});

export const updateScheduleFormLanguageInput = (value) => ({
  type: Constants.SCHEDULE_FORM_LANGUAGE_CHANGE,
  payload: value,
});

export const updateScheduleFormDescriptionInput = (value) => ({
  type: Constants.SCHEDULE_FORM_DESCRIPTION_CHANGE,
  payload: value,
});
